const HelpDeskPage = () => {
  return (
    <div className='p-6 bg-gray-50 min-h-full'>
      <div className='max-w-6xl'>{/* Help Desk content will go here */}</div>
    </div>
  );
};

export default HelpDeskPage;
